module.exports = __webpack_public_path__ + "newprotal/img/num1.19cc2770.png";